export const CUSTOM_GROUP = {
  ALL_EMPLOYEES: 'All Employees',
  ALL_EMPLOYEES_: 'All Other Employees ',
  OTHER_EMPLOYEES: 'All Other Employees',
};

export const COMPENSATION_NAME = {
  BASE_SALARY: 'Base Salary',
};

export const INDIVIDUAL_PAY_DETAIL_KEYS = {
  EMPLOYEE_NAME: 'employee_name',
};

export function isVariablePayStiOrLtiByName(compensationName: string): boolean {
  const name = (compensationName ?? '').toLowerCase();
  return (
    name.includes('sti') ||
    name.includes('bonus') ||
    name.includes('lti') ||
    name.includes('equity') ||
    name.includes('stock')
  );
}
export function isVariablePayStiRequiredByName(compensationName: string): boolean {
  const name = (compensationName ?? '').toLowerCase();
  if (name.includes('lti')) return false;
  return name.includes('sti') || name.includes('bonus');
}
